import { useState } from "react";
import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Loader } from "components";
import { useFeatureFlags } from "swing-components";

import { FilterBar } from "~components/Organisms/IndexFilters";
import { initialLocalStorageFilterValues } from "~components/Organisms/IndexFilters/types";
import { IndexSearch } from "~components/Organisms/IndexSearch";
import { translate, useLocalStorage } from "~utils";

import { useRequests } from "./hooks";
import { NoRequestsWithSearchTerm } from "./NoRequests";
import { RequestCount } from "./RequestCount";
import { RequestIndex } from "./RequestIndex";

export function ActiveRequestsPage() {
  const [ls, setLs] = useLocalStorage(
    "swing-schools:filters:active",
    initialLocalStorageFilterValues,
  );

  const [searchTerm, setSearchTerm] = useState("");

  const { flags } = useFeatureFlags();
  const showSearch = flags.adminIndexSearch;

  const { data, isError, isFetching } = useRequests({
    showHistory: false,
    filters: ls,
    searchTerm: showSearch ? searchTerm : undefined,
  });

  if (!data) return <Loader />;

  const { requests } = data;

  return (
    <>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle size="large">{translate("ROUTE_TABLE_ACTIVE_REQUESTS")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {showSearch && <IndexSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} />}
      <FilterBar page="active" ls={ls} setLs={setLs}></FilterBar>
      {isFetching && searchTerm ? (
        <NoRequestsWithSearchTerm searchTerm={searchTerm} page="active" />
      ) : (
        <>
          <RequestCount page="active" count={data.total} />
          <RequestIndex
            requestType="active-requests"
            requests={requests}
            isError={isError}
            hasNextPage={data.hasNextPage}
            fetchNextPage={data.fetchNextPage}
            isFetchingNextPage={data.isFetchingNextPage}
          />
        </>
      )}
    </>
  );
}
